import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import TerminationAuditListView from './components/TerminationAuditListView';
import { FISCAL_TERMINATION_AUDIT_CONFIG } from './config';

const FiscalTerminationAuditPage = () => (
  <TerminationAuditListView config={FISCAL_TERMINATION_AUDIT_CONFIG} />
);

const FiscalTerminationAuditView = () => {
  return (
    <>
      <RolePrivateRoute component={FiscalTerminationAuditPage} />
    </>
  );
};

export default FiscalTerminationAuditView;
